<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listStatusOs"
        title-table="Status OS"
        module="statusOsModule"
        sort-name="descricao"
        add-permission="ROLE_STATUS_OS_INSERIR"
        delete-permission="ROLE_STATUS_OS_DELETAR"
        view-permission="ROLE_STATUS_OS_CONSULTAR"
        edit-permission="ROLE_STATUS_OS_ATUALIZAR"
        @add="addNew"
        @edit="edit"
      />
      <StatusOsForm
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'

import StatusOsForm from './form/StatusOsForm.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    StatusOsForm,
  },
  computed: {
    ...mapState('statusOsModule', {
      listStatusOs: state => state.listStatusOs,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('statusOsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('statusOsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
